import axios from 'axios';

const api = axios.create({
  // Puxa a URL base do seu arquivo .env do React
  baseURL: process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : 'http://localhost:3030/api',
  
  // Pula a tela de bloqueio do ngrok para os dados passarem direto
  headers: {
    'ngrok-skip-browser-warning': 'true'
  }
});

// 1. INTERCEPTADOR DE IDA (Request)
// Anexa o token de segurança em todas as requisições que saem do React
api.interceptors.request.use(async config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 2. INTERCEPTADOR DE VOLTA (Response) - LOGOUT AUTOMÁTICO
api.interceptors.response.use(
  (response) => {
    // Se a requisição deu certo (Status 200, 201), apenas deixa passar
    return response;
  },
  (error) => {
    // Se o backend retornar 401 (Não Autorizado / Token Expirado)
    if (error.response && error.response.status === 401) {
      
      // Limpa os dados do usuário vencido da memória do navegador
      localStorage.removeItem('token');
      localStorage.removeItem('user_name');
      
      // Exibe o alerta amigável
      alert('Sua sessão expirou por inatividade. Por favor, faça login novamente.');
      
      // Redireciona na marra para a tela de login (limpando o estado do React)
      window.location.href = '/jb-login-acesso-master-control-cms';
    }
    
    return Promise.reject(error);
  }
);

export default api;